import React from 'react';
import algoliasearch from 'algoliasearch/lite';
import { InstantSearch, SearchBox, Hits, Highlight, useHits, Configure } from 'react-instantsearch';
import styled from 'styled-components';

const algoliaClient = algoliasearch('PY4BD5F6JD', '3db26bfb121e0b734a2c0dbaa63f7568');

const searchClient = {
  ...algoliaClient,
  search(requests) {
    if (requests.every(({ params }) => !params.query)) {
      return Promise.resolve({
        results: requests.map(() => ({
          hits: [],
          nbHits: 0,
          nbPages: 0,
          page: 0,
          processingTimeMS: 0,
          hitsPerPage: 0,
          exhaustiveNbHits: false,
          query: '',
          params: '',
        })),
      });
    }
    return algoliaClient.search(requests);
  },
};

export default function InstantSearchWidget() {
  const [isFocused, setIsFocused] = React.useState(false);

  React.useEffect(() => {
    const rootElem = document.getElementById("instantsearch_root")
    if (rootElem) {
      rootElem.classList.remove("is-loading")
    }
  }, []);
  
  return (
    <Container>
      <InstantSearch searchClient={searchClient} indexName="gnedi_products" >
        <Configure hitsPerPage={9} />  
        <header>
          <StyledSearchBox
            resetIconComponent={() => null}
            placeholder="Search"
            submitIconComponent={() => <MagnifyingGlassIcon />} 
            onFocus={() => setIsFocused(true)}
            onBlur={() => setIsFocused(false)}
            className={isFocused ? 'focused' : null}
            onSubmit={(e) => {
              const query = e.target[0].value
              window.location.href = `/filterSearch?q=${query}`
            }}
          />
        </header>
        <Results />
      </InstantSearch>
    </Container>
  );
}

function Results() {
  const { hits } = useHits();
  if (!hits?.length) {
    return null;
  }
  return (
    <main>
      <StyledHits hitComponent={Hit} />
    </main>
  )
}


function Hit({ hit }) {
  const resolvedImagename = hit.ImageFilename !== ""
        ? `http://www.gnedi.com/images/thumbs/${hit.ImageFilename}`
        : "https://www.gnedi.com/images/thumbs/default-image_360.png";

        const encodedSlug = encodeURIComponent(hit.Slug);
  return (
    <HitContainer>
      <a href={`/${encodedSlug}`}>
        <span className="image-wrapper">
          <img src={resolvedImagename} alt={hit.Name} />
        </span>
        <span className="details">
          <h4 className="description"><Highlight attribute="Name" hit={hit} /></h4>
          <p className="sku">SKU: {hit.Sku}</p>
        </span>
      </a>
    </HitContainer>
  );
}

const StyledHits = styled(Hits)`
  position: absolute;
  z-index: 10000;
  background-color: white;
  border: 1px solid #ccc;
  max-width: 100%;

  .ais-Hits-list {
    list-style-type: none;
    margin: 0;
    padding: 0;
    overflow-y: auto;
    max-height: calc(100vh - 90px);
  }
`;

const Container = styled.div`
  position: relative;

  display: flex;
  flex-flow: column;
  text-align: left;
  max-width: 1200px;

  header {
    display: flex;
    flex-flow: row nowrap;
    align-items: center;
    gap: 20px;
  }

  main {
    display: flex;
    flex-flow: row nowrap;
    gap: 20px;
  }

  .ais-SearchBox {
    width: 100%;
  }
`;

const HitContainer = styled.article`
  border-bottom: 1px solid #ccc;
  padding: 10px;

  .description {
    color: #555;
    font-size: 16px;
    max-height: 48px;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  .sku {
    color: #555;
    font-size: 14px;
  }

  &:hover {
    background-color: #eee;
    cursor: pointer;
  }

  a {
    display: flex;
    flex-flow: row nowrap;
    gap: 20px;
    align-items: center;
    text-decoration: none;
  }

  .image-wrapper {
    width: 60px;
    min-width: 60px;
    height: 60px;
    overflow: hidden;
    display: flex;
    justify-content: center;
    align-items: center;

    img {
      width: 100%;
    }
  }
`

const StyledSearchBox = styled(SearchBox)`
  border: 2px solid var(--color--dark-grey);
  border-radius: 5px;

  &:hover, &.focused {
    border-color: var(--color--dark-green);
  }

  .ais-SearchBox-form {
    display: flex;
    flex-flow: row nowrap;
    align-items: center;
    gap: 0;
    width: 100%;
    height: 100%;
  }
  
  .ais-SearchBox-input {
    font-size: 16px;
    border: none;
    padding: 10px;
    width: 300px;
    flex: 1;

    @media (min-width:1281px) {
      width: 475px;
    }

    &:focus {
      outline: none;
    }

    &::-webkit-search-cancel-button{
      display: none;
    }
  }

  .ais-SearchBox-submit {
    border: none;
    border-left: 1px solid #ccc;
    background: white;
    height: 100%;
    padding: 8px;
    cursor: pointer;

    &:hover {
      background-color: #eee;
    }
  }

  .ais-SearchBox-reset {
    display: none;
  }
`

const MagnifyingGlassIcon = styled.span`
  display: block;
  width: 20px;
  height: 20px;
  background: url(https://www.gnedi.com/Themes/Traction/Content/img/search-button-g.png) center no-repeat;
  cursor: pointer;
`